import { Injectable, inject } from '@angular/core';

import { CoreActions } from '@next/core-lib';

import { createEffect, ofType, Actions } from '@ngrx/effects';
import { first, concatMap, map } from 'rxjs/operators';

import * as AppActions from './actions';
import { NutrientService } from '../services/nutrient.service';

@Injectable()
export class AppEffects {
  private readonly api = inject(NutrientService);
  private readonly actions$ = inject(Actions);

  loadDataAfterBrowserInitialized$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CoreActions.browserInitialized),
      first(),
      concatMap(() =>
        this.api
          .getNutrients()
          .pipe(
            map((nutrients) => AppActions.loadNutrientsSuccess({ nutrients: nutrients.nutrients })),
          ),
      ),
    ),
  );

  constructor() {}
}
